import React from "react";
import { Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import Frame from "../Frame/index.js";
import styles from "./SpringDealBanner.module.css";
import { SPRING_DEAL_BG_COLOR, SPRING_DEAL_IMAGE_URL_INDEX_SMALL } from "../../../constants.js";
const SpringDealBanner = () => {
    const i18n = useI18n();
    return (React.createElement(Frame, { attributes: { style: { width: "100%" } }, grow: 1 },
        React.createElement(Stack, { direction: "column", justifyContent: "center", alignItems: "start", className: styles.container, attributes: {
                style: {
                    background: `linear-gradient(90deg, rgba(0, 0, 0, 0.80) 45.19%, rgba(0, 0, 0, 0.00) 100%), url(${SPRING_DEAL_IMAGE_URL_INDEX_SMALL}) ${SPRING_DEAL_BG_COLOR}`,
                    backgroundSize: "100% auto",
                    backgroundPosition: "center 0px",
                    backgroundRepeat: "no-repeat"
                }
            } },
            React.createElement(Text, { color: "white", variant: "strong_2", attributes: { style: { maxWidth: "80%" } } }, i18n.trans(t("flights_spring26_mdot_index_header"))),
            React.createElement(Text, { color: "white", variant: "body_2", attributes: { style: { maxWidth: "80%" } } }, i18n.trans(t("flights_spring26_mdot_index_subheader"))))));
};
export default SpringDealBanner;
